import React from 'react';
import PropTypes from 'prop-types';
import {Col, ControlLabel, FormGroup, Row} from "react-bootstrap";
import Page from "../../component/Page/Page";
import Box from "../../component/Box/Box";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import AssetDetail from "../../component/Asset/AssetDetail";
import AssetTimeline from "../../component/Asset/AssetTimeline";
import Objects from "../../utils/Objects";

class EPCTrackPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      epcValue: null
    };
    this.researchEPC = this.researchEPC.bind(this);
  }

  componentWillMount() {
    this.mountData(this.props);
  }

  mountData(props) {
    const {match} = props;
    const epc = match.params.epc;
    this.setState({epc: epc, epcValue: epc, loading: true});
  }

  componentWillReceiveProps(nextProps) {
    const {match} = nextProps;
    if (this.props.match.params.epc !== match.params.epc) {
      this.mountData(nextProps);
    }
  }

  researchEPC(event) {
    if (event) {
      event.preventDefault();
    }
    if (this.epc.value !== this.state.epc) {
      this.props.history.push('/track/' + this.epc.value);
    }
  }

  render() {
    const {epc, epcValue} = this.state;

    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Rastreabilidade"/>,
      <BreadcrumbItem key={2} title="Timeline" active={true}/>];

    return (
        <Page breadcrumbs={breadcrumbs} {...this.props}>
          <Box tema='finder'>
            <FormGroup>
              <ControlLabel>Buscar por EPC</ControlLabel>
              <div className="input-group">
                <input type="text" className="form-control" placeholder="EPC"
                       name="epc" id="epc" ref={epc => (this.epc = epc)}
                       onChange={e => this.setState({ epcValue: e.target.value })}
                       onKeyPress={event => {
                         if (event.key === 'Enter') {
                           this.researchEPC();
                         }
                       }}
                       value={epcValue}/>
                <div className="input-group-addon">
                  <a href="" onClick={this.researchEPC} placeholder="EPC">
                    <i className="fa fa-search"></i>
                  </a>
                </div>
              </div>
            </FormGroup>
          </Box>

          {!Objects.isEmptyOrBlank(epc) ? <Row>
            <Col md={6}>
              <AssetDetail epc={epc}/>
            </Col>
            <Col md={6}>
              <AssetTimeline epc={epc}/>
            </Col>
          </Row> : ''}
        </Page>
    );
  }
}

EPCTrackPage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default EPCTrackPage;




// WEBPACK FOOTER //
// ./src/pages/Asset/EPCTrackPage.js